import { Grid, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react';
import { MessageIconNew, WarningCircle } from '../../../assets/images';
import { useAppSelector } from '../../../store/hooks';
import { red } from '../../../theme/palette';
import { getCustomerVoiceSectionAttributes } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { LOCAL_STORAGE_KEYS, Module, isModuleConfig } from '../../../constants';
import { MuiIconButton } from '../../../builderPackage/components';
import { MuiStack, MuiButton, MuiPopup } from '../../../components';
import MapView from '../../../components/templates/roadTest/mapView';
import moment from 'moment';
// interface Props {
//     onDataUpdate: (data: {
//       currentPosition: any;
//       distance: number;
//       roadTestStatus: string;
//     }) => void;
//   }
export default function RoadTestMap(props) {
    var _Date, _getCustomerVoiceSect, _getCustomerVoiceSect2;
    var isviewOnly = props.isviewOnly, onSkipTest = props.onSkipTest, handleClick = props.handleClick, onClickRoadTestVehicleDetails = props.onClickRoadTestVehicleDetails, onStartTest = props.onStartTest, onClickNext = props.onClickNext, onClickEndTest = props.onClickEndTest, _a = props.isDraftJC, isDraftJC = _a === void 0 ? false : _a, pathCordinates = props.pathCordinates, coveredDistance = props.coveredDistance, timeDuration = props.timeDuration, _b = props.index, index = _b === void 0 ? 0 : _b, onClickMsgIcon = props.onClickMsgIcon, onClickRoadTestTraslate = props.onClickRoadTestTraslate, _c = props.isTestDone, isTestDone = _c === void 0 ? false : _c, isDisabled = props.isDisabled;
    var getModuleHeaderCount = useAppSelector(function (state) { return state.crud; }).getModuleHeaderCount;
    var customerVoiceSectionDetails = useSelector(function (state) { return state.common; }).customerVoiceSectionDetails;
    var isSmallScreen = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var _d = useState(), currentPosition = _d[0], setCurrentPosition = _d[1];
    var _e = useState(false), isOpenSkipTestPopup = _e[0], setIsOpenSkipTestPopup = _e[1];
    var _f = useState(false), isTestStarted = _f[0], setIsTestStarted = _f[1];
    var _g = useState(isTestDone), isTestEnd = _g[0], setIsTestEnd = _g[1];
    var _h = useState(coveredDistance !== null && coveredDistance !== void 0 ? coveredDistance : null), distance = _h[0], setDistance = _h[1];
    var _j = useState(0), duration = _j[0], setDuration = _j[1];
    var _k = useState(null), timerId = _k[0], setTimerId = _k[1];
    var _l = useState([]), path = _l[0], setPath = _l[1];
    var _m = useState(pathCordinates !== null && pathCordinates !== void 0 ? pathCordinates : []), pathCoordinates = _m[0], setPathCoordinates = _m[1];
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var _o = useState(false), isLocationEnabled = _o[0], setIsLocationEnabled = _o[1];
    var _p = useState('not started'), roadTestStatus = _p[0], setRoadTestStatus = _p[1];
    var _q = useState(0), startTestTimeStamp = _q[0], setStartTestTimeStamp = _q[1];
    var onDataUpdate = props.onDataUpdate;
    console.log('currentPosition', currentPosition);
    console.log('distance', distance);
    console.log('roadTestStatus', roadTestStatus);
    var startDateTimeRef = useRef((_Date = new Date()) === null || _Date === void 0 ? void 0 : _Date.toISOString());
    useEffect(function () {
        var _Date2;
        // Log locally
        console.log('currentPosition', currentPosition);
        console.log('distance', distance);
        console.log('roadTestStatus', roadTestStatus);
        var endDateTime = (_Date2 = new Date()) === null || _Date2 === void 0 ? void 0 : _Date2.toISOString();
        // Send data back to parent
        onDataUpdate === null || onDataUpdate === void 0 || onDataUpdate({
            currentPosition: currentPosition,
            distance: distance,
            roadTestStatus: roadTestStatus,
            StartDateTime: startDateTimeRef === null || startDateTimeRef === void 0 ? void 0 : startDateTimeRef.current,
            EndDateTime: endDateTime
        });
    }, [currentPosition, distance, roadTestStatus]);
    useEffect(function () {
        getCurrentLocation();
    }, []);
    useEffect(function () {
        getRoadTestDetails();
    }, [pathCordinates, coveredDistance, timeDuration]);
    var getRoadTestDetails = function () {
        if (pathCoordinates)
            setPathCoordinates(pathCordinates);
        if (coveredDistance)
            setDistance(coveredDistance);
        if (timeDuration) {
            setDuration(timeDuration);
            setIsTestEnd(true);
        }
    };
    function convertSecondsToFormattedTime(seconds) {
        // Calculate minutes and remaining seconds
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        var formattedTime = "".concat(seconds, " Sec");
        if (minutes === 0) {
            formattedTime = "".concat(remainingSeconds, " Sec");
        }
        else {
            formattedTime = "".concat(minutes, " Min ").concat(remainingSeconds, " Sec");
        }
        return formattedTime;
    }
    function getCurrentLocation() {
        return new Promise(function (resolve, reject) {
            // Asynchronous code to get the location
            navigator.geolocation.getCurrentPosition(function (_ref) {
                var _a = _ref.coords, lat = _a.latitude, lng = _a.longitude;
                var pos = {
                    lat: lat,
                    lng: lng
                };
                setCurrentPosition(pos);
                resolve(pos);
                setIsLocationEnabled(true);
            }, function (error) {
                console.error("error", error);
                setIsLocationEnabled(false);
                alert("Geolocation is not enable by your browser.");
            });
        });
    }
    var handleSkipTest = function () {
        setIsOpenSkipTestPopup(true);
    };
    var onCloseSkipTest = function () {
        setIsOpenSkipTestPopup(false);
    };
    var handleConfirm = function () {
        setIsOpenSkipTestPopup(false);
        if (onSkipTest) {
            onSkipTest();
        }
    };
    var onStartOrEndTest = function () {
        if (isTestStarted) {
            setIsTestStarted(false);
            setIsTestEnd(true);
            setRoadTestStatus('ended');
            if (onClickEndTest) {
                onClickEndTest(duration, distance, path);
            }
        }
        else {
            setStartTestTimeStamp(+new Date());
            setIsTestStarted(true);
            setRoadTestStatus('started');
            if (onStartTest) {
                onStartTest(currentPosition);
            }
        }
    };
    var handleOnClickNext = function () {
        if (onClickNext) {
            onClickNext();
        }
    };
    var handleClickViewJobs = function () {
        if (onClickRoadTestVehicleDetails) {
            onClickRoadTestVehicleDetails(true);
        }
    };
    var handleMsgClick = function () {
        if (onClickMsgIcon) {
            onClickMsgIcon(true);
        }
    };
    var handleChangePath = function (path) {
        setPath(path);
    };
    var handleRoadTestTraslate = function () {
        if (onClickRoadTestTraslate) {
            onClickRoadTestTraslate(true);
        }
    };
    var getDistanceFormat = function (distance) {
        if (distance && !Number.isNaN(distance)) {
            if (distance >= 1000) {
                var distanceInKms = distance / 1000;
                return "".concat(distanceInKms.toFixed(2), " KM");
            }
            else {
                return "".concat(distance, " meters");
            }
        }
        else {
            return '0 meters';
        }
    };
    var handleEndTest = function (distance, path) {
        var timeDiff = moment().diff(moment(startTestTimeStamp), 'seconds');
        setDuration(timeDiff);
        if (onClickEndTest) {
            setDistance(distance);
            console.log("___API DETAILS ", distance, timeDiff, path);
            onClickEndTest(timeDiff, distance, path);
        }
    };
    console.log('I am road Test', isTestEnd);
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: isDraftJC ? 0 : 0,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        lg: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(MapView, {
        roadTestStatus: roadTestStatus,
        currentPosition: currentPosition,
        endTestHandler: handleEndTest,
        setDistance: setDistance,
        existingCoords: pathCoordinates
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0,
        direction: "column"
    }, (roadTestStatus === 'ended' || roadTestStatus === 'not started') && /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 2,
        paddingY: 1,
        justifyContent: "space-between",
        width: "100%",
        bgcolor: "#EFF2F5"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#8593A3"
    }, t("Distance"), ": ", " "), /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1"
    }, getDistanceFormat(distance))), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#8593A3"
    }, t("Duration"), ": ", " "), /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1"
    }, convertSecondsToFormattedTime(parseInt(duration.toFixed()))))), !isTestEnd && !isviewOnly && /*#__PURE__*/ React.createElement(MuiButton, {
        id: "test-ride-start-end-btn",
        variant: "contained",
        size: "medium",
        color: "primary",
        name: isTestStarted ? t("End test") : t("Start test"),
        fullWidth: isSmallScreen,
        onClick: onStartOrEndTest,
        disabled: isDisabled || !isLocationEnabled,
        style: {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            opacity: isDisabled ? 0.7 : 1
        }
    }), (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) !== "FinalInspector" && /*#__PURE__*/ React.createElement(React.Fragment, null, isTestEnd && !isviewOnly && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        alignItems: "center",
        paddingY: 0.5,
        paddingX: 1,
        border: "1px solid #DEE4EB",
        sx: {
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: "8px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "translate-to-jobitems-btn",
        name: Module === isModuleConfig.Bajaj ? t('Add more job items') : t('TRANSLATE_TO_JOB_ITEM'),
        variant: "text"
        // style={{ opacity: isDisabled ? 0.7 : 1}}
        ,
        onClick: handleRoadTestTraslate
    }), /*#__PURE__*/ React.createElement(Typography, {
        style: {
            padding: 1,
            borderRadius: '20px',
            border: '1px solid #AFD5FF',
            width: (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems) > 99 ? '40px' : '30px',
            height: '30px',
            marginLeft: '10px',
            backgroundColor: '#EEF6FF'
        },
        align: "center",
        color: "#AFD5FF"
    }, getModuleHeaderCount && getModuleHeaderCount !== null && getModuleHeaderCount !== void 0 && getModuleHeaderCount.jobItems ? getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems : 0)), customerVoiceSectionDetails && !((_getCustomerVoiceSect = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect !== void 0 && (_getCustomerVoiceSect = _getCustomerVoiceSect.OVERALL_COMMENTS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect !== void 0 && _getCustomerVoiceSect.HIDE) && /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "translae-tojob-message-btn",
        onClick: handleMsgClick
    }, /*#__PURE__*/ React.createElement("img", {
        src: MessageIconNew
    }))), isviewOnly && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        alignItems: "center",
        paddingY: 0.5,
        paddingX: 1,
        border: "1px solid #DEE4EB",
        sx: {
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: "8px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "view-jobs-btn",
        name: t('View jobs'),
        variant: "text"
        //style={{ opacity: isDisabled ? 0.7 : 1}}
        ,
        onClick: handleClickViewJobs
    }), /*#__PURE__*/ React.createElement(Typography, {
        style: {
            borderRadius: '20px',
            border: '1px solid #AFD5FF',
            width: '25px',
            height: '25px',
            marginLeft: '10px',
            backgroundColor: '#EEF6FF'
        },
        align: "center",
        color: "#AFD5FF"
    }, getModuleHeaderCount ? getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems : 0)), customerVoiceSectionDetails && !((_getCustomerVoiceSect2 = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect2 !== void 0 && (_getCustomerVoiceSect2 = _getCustomerVoiceSect2.OVERALL_COMMENTS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect2 !== void 0 && _getCustomerVoiceSect2.HIDE) && /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "translae-tojob-message-btn",
        onClick: handleMsgClick
    }, /*#__PURE__*/ React.createElement("img", {
        src: MessageIconNew
    })))))))), /*#__PURE__*/ React.createElement(MuiPopup, {
        title: t('Warning'),
        openPopup: isOpenSkipTestPopup,
        onClose: onCloseSkipTest,
        variant: "h1",
        subTitle: t("Are you sure you want to skip road test."),
        WarningCircle: WarningCircle,
        padding: '15px'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 7,
        md: 7,
        sm: 7,
        xs: 6,
        sx: {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "cancel-test-ride-btn",
        variant: "outlined",
        size: "large",
        color: "primary",
        style: {
            borderColor: red
        },
        name: t("Cancel"),
        onClick: onCloseSkipTest
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 5,
        md: 5,
        sm: 5,
        xs: 6,
        sx: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "confirm-test-ride-btn",
        variant: "contained",
        size: "large",
        color: "primary",
        name: t("Confirm"),
        onClick: handleConfirm
    })))));
}
